/**
 * Design Tokens for Weidner Apartment Homes Theme
 * 
 * Extends the base avenue theme tokens with Weidner Apartment Homes branding.
 */

import type { DesignTokens } from '@vibesites/tokens';
import { tokens as baseTokens } from '@vibesites/theme-avenue/tokens';
import { defaultTokens } from '@vibesites/tokens';

/**
 * Weidner Apartment Homes brand colors and typography.
 * Customize these values to match your brand guidelines.
 */
export const tokens: Partial<DesignTokens> = {
  color: {
    ...defaultTokens.color,
    ...baseTokens.color,
  },
  font: {
    ...defaultTokens.font,
    ...baseTokens.font,
  },
  fontSize: {
    ...defaultTokens.fontSize,
    ...baseTokens.fontSize,
  },
  fontWeight: {
    ...defaultTokens.fontWeight,
    ...baseTokens.fontWeight,
  },
  spacing: {
    ...defaultTokens.spacing,
    ...baseTokens.spacing,
  },
  radius: {
    ...defaultTokens.radius,
    ...baseTokens.radius,
  },
  shadow: {
    ...defaultTokens.shadow,
    ...baseTokens.shadow,
  },
  transition: {
    ...defaultTokens.transition,
    ...baseTokens.transition,
  },
};

export default tokens;
